module.exports = __webpack_public_path__ + "static/img/shengjimingdai_icon.59e3d3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/shengjimingdai_icon.png
// module id = NZ6m
// module chunks = 1